module.exports = __webpack_public_path__ + "img/logo-icon-9.6539527f.png";